/* Dependancies */
import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { DatePipe } from "@angular/common";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatSidenavModule } from "@angular/material/sidenav";
import { MatButtonModule } from "@angular/material/button";
import { MatStepperModule } from "@angular/material/stepper";
import { MatListModule } from "@angular/material/list";
import { MatCardModule } from "@angular/material/card";
import { MatGridListModule } from "@angular/material/grid-list";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatSelectModule } from "@angular/material/select";
import { HttpClientModule } from "@angular/common/http";
import { MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatRadioModule } from "@angular/material/radio";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatNativeDateModule, MAT_DATE_LOCALE } from "@angular/material/core";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatTableModule } from "@angular/material/table";
import { MatChipsModule } from "@angular/material/chips";
// import { MatBadgeModule } from "@angular/material/badge";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { MatTreeModule } from "@angular/material/tree";
import { NgxSliderModule } from "@angular-slider/ngx-slider";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatMenuModule } from "@angular/material/menu";
import { MatTabsModule } from "@angular/material/tabs";
import { MatExpansionModule } from "@angular/material/expansion";
import { ColorPickerModule } from "ngx-color-picker";
// import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { ProgressBarModule } from "angular-progress-bar";
import { Ng2TelInputModule } from "ng2-tel-input";
import { NgCircleProgressModule } from "ng-circle-progress";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import { NgxEmojiPickerModule } from "ngx-emoji-picker";
import { MentionModule } from "angular-mentions";

/* App */
import { AppComponent } from "./app.component";
import { AppRoutingModule } from "./app-routing.module";

/* Services */
import { ApiCallService } from "./core/services/api-call-service";
import { ErrorHandler } from "./core/services/error-handler";
import { EventsService } from "./core/services/events.service";
import { create360dialogaccoountService } from "./core/services/create-360-dialog-account-service";
import { FontCollection } from "./core/services/fonts-collection";
import { SnackbarCollection } from "./core/services/snackbar.service";
import { WindowRef } from "./core/services/windowRef.service";
import { Globals } from "./core/services/global.service";
import { PygApiCallService } from "./core/services/pyg-apicall.service";
import { ParentChildService } from "./core/services/parent-child.service";
import { WidgetConfigService } from "./core/services/widget-config.service";
import { WidgetRouteGaurdService } from "./core/services/widget-route-gaurd.service";
import { EventIconMappingService } from "./core/services/event-icon-mapping.service";
import { SubscriptionPlanHandlerService } from "./core/services/subscription-plan-handler.service";
import { currentPlanDataService } from "./core/services/current-plan-global.service";
import { SignoutService } from "./core/services/signout.service";
import { environment } from "src/environments/environment";

/* Pipes */
// import {  TruncatePipe, NumberToIterablePipe, FilterPipe, RemoveUnderscorePipe, ReversePipe, CurrencySymbolPipe, IsCheckedPYG, IsChecked, ToDateObjPipe, BoldTextPipe } from "./shared/pipes";

/* Models */
import { dataBase } from "./shared/models/model";

/* Interceptor */
import { httpInterceptorProviders } from "./core/auth/auth-interceptor";

/* Directives */
// import { ButtonDebounceDirective } from "./shared/directives";

/* Components */
// import { BreadcrumbComponent } from "./modules/pos/components/breadcrumb/breadcrumb.component";
// import { PieChartComponent, BarChartComponent, VennDiagramComponent, LineChartComponent, BubbleChartAdComponent, HeatMapComponent, LineChartWithTooltipComponent, MultiLineChartComponent, StackedBarChartComponent, MultiLineChartTtComponent, DonutChartComponent, InsightsBarChartComponent, SegmentLineChartComponent, SegmentCustomerCountBarChartComponent, NegotiatorSingleGameGraphComponent, RevenueRewardsChartComponent, RevenueOfferChartComponent, ProductsSoldChartComponent } from "./shared/components/charts";
import {
  SignupDialogComponent,
  EcommerceDialogComponent,
  ContactUsDialogComponent,
  OfferTemplateViewDialogComponent,
  CampaignTemplateViewDialogComponent,
  ConfirmationDialogBoxComponent,
  PopUpDialogComponent,
  SurveyPageCreationComponent,
  CamapignStrategyNodeDataComponent,
  CampaignStrategyDialogComponent,
  CampaignStrategyTooltipComponent,
  CustomerLeadsComponent,
  EmailEditorDialogComponent,
  HtmlDataDialogComponent,
  CommonTooltipDialogComponent,
  StandardCampaignActivateDialogComponent,
  SurveyAlertRecommendationDialogComponent,
  AddEmailSubjectDialogComponent,
  TemplateSelectComponent,
  HtmlForEmailTemplatesDialogComponent,
  BeeEditorProductImageConfigDialogComponent,
  DeleteDialogComponent,
  NodeDeleteBranchSelectorComponent,
  CampaignStrategyActivateDialogComponent,
  PreviewTemplateComponent,
  SuccessDialogComponent,
  SurveySchedulesSuccessComponent,
  SmsTemplateCreationDialogComponent,
  SmsScheduleDialogComponent,
  SmsPreviewDialogComponent,
  SelectOfferTypeDialogComponent,
  OfferSummaryDialogComponent,
  OfferChannelAddConfirmationDialogComponent,
  SmsPreviewIdDialogComponent,
  TargetingDialogComponent,
  PlanFeaturesComponent,
  OfferAddProductDialogComponent,
  ProductListDialogComponent,
  CollectionListDialogComponent,
  DataFetchingDialogComponent,
  SendTestEmailDialogComponent,
  DomainConfirmationDialogPopUpComponent,
  InactivePlanDialogComponent,
  ProductGameListDialogComponent,
  NameAndDescriptionComponent,
  InvitePartnerDialogComponent,
  PartnershipRewardCreationDialogboxComponent,
  PartnershipInitiateDialogBoxComponent,
  PartnershipSendOfferDialogboxComponent,
  ConnectPaypalComponent,
  DisablePartnershipOfferComponent,
  UpdateFormComponent,
  ExcludeProductDialogComponent,
  DialogOverviewComponent,
  DeleteGameDialogBoxComponent,
  SocialMediaConnectChannelDialogComponent,
  SocialMediaPagesSelectDialogComponent,
  OfferCreateDialogComponent,
  SearchCustomerDialogBoxComponent,
  TableViewDialogBoxComponent,
  NotDeletedListDialogBoxComponent,
  SearchModulesDialogBoxComponent,
  AnalyticsCustomerListDialogBoxComponent,
  AbGraphInsightDialogComponent,
  SendTestSmsDialogComponent,
  SelectionChallengeTypeDialogComponent,
  MilestoneCreationDialogComponent,
  PushNotificationPreviewDialogBoxComponent,
} from "./shared/components/dialog-box";
import {
  StaticPageComponent,
  SessionOutComponent,
  MobileAlertComponent,
  WelcomeWidgetComponent,
  MobileEmailPreviewComponent,
  NotFoundComponent,
} from "./modules/static/pages";
import {
  StaticFooterComponent,
  StaticHeaderComponent,
} from "./modules/static/components";
import { NgxMaterialTimepickerModule } from "ngx-material-timepicker";
import { MatSnackBarComponent } from "./shared/components/mat-snack-bar/mat-snack-bar.component";
import { PaymentPlanComponent } from "./shared/components/payment-plan/payment-plan.component";
import { EmailTemplatePreviewComponent } from "./shared/components/email-template-preview/email-template-preview.component";
import { SharedModule } from "./modules/shared/shared-module";
import { NegotiatorTemplatePreviewComponent } from "./shared/components/negotiator-template-preview/negotiator-template-preview.component";
import { OfferRulesImportDialogComponent } from "./shared/components/dialog-box/offer-rules-import-dialog/offer-rules-import-dialog.component";
import { EmailTemplateCreationDialogComponent } from "./shared/components/email-template-creation-dialog/email-template-creation-dialog.component";
import { DisableFormComponent } from "./shared/components/dialog-box/disable-form/disable-form.component";
import { SendSmsConsentDialogBoxComponent } from "./shared/components/dialog-box/send-sms-consent-dialog-box/send-sms-consent-dialog-box.component";
import { MyStorePreviewComponent } from "./modules/pos/modules/user-profile/pages/my-store-preview/my-store-preview.component";
import { AgmCoreModule } from "@agm/core";
import { SelectStoreDialogBoxComponent } from "./shared/components/dialog-box/select-store-dialog-box/select-store-dialog-box.component";
import { ViewStoreDialogBoxComponent } from "./shared/components/dialog-box/view-store-dialog-box/view-store-dialog-box.component";
import { PaymentPosSucessDialogComponent } from "./shared/components/dialog-box/payment-pos-sucess-dialog/payment-pos-sucess-dialog.component";
import { MatIconModule } from "@angular/material/icon";
//import { CampaignHowToCreateComponent } from './modules/pos/modules/campaign/component/campaign-how-to-create/campaign-how-to-create.component';
//import { SetUpCampaignComponent } from './modules/pos/modules/campaign/pages/set-up-campaign/set-up-campaign.component';
// import { CampaignAddFilterComponent } from "./modules/pos/modules/campaign/component/campaign-add-filter/campaign-add-filter.component";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { AiEmailCreationComponent } from "./shared/components/dialog-box/ai-email-creation/ai-email-creation.component";
import { AnalyticsChatGptComponent } from "./shared/components/dialog-box/analytics-chat-gpt/analytics-chat-gpt.component";
import { CampaignFullscreenComponent } from "./shared/components/dialog-box/campaign-fullscreen/campaign-fullscreen.component";
import { EmailNotVerifiedDialogBoxComponent } from "./shared/components/dialog-box/email-not-verified-dialog-box/email-not-verified-dialog-box.component";
import { OfferCreateChatGptDialogBoxComponent } from "./shared/components/dialog-box/offer-create-chat-gpt-dialog-box/offer-create-chat-gpt-dialog-box.component";
import { WhatsappTemplateCreationDialogComponent } from "./shared/components/dialog-box/whatsapp-template-creation-dialog/whatsapp-template-creation-dialog.component";
import { EmojiPickerLazyModule } from "./subcomponents/ngx-emoji-picker/emoji-picker-lazy.module";
import { OfferSelectDoalogBoxComponent } from "./shared/components/dialog-box/offer-select-doalog-box/offer-select-doalog-box.component";
import { GroupOfferSucessDialogBoxComponent } from "./shared/components/dialog-box/group-offer-sucess-dialog-box/group-offer-sucess-dialog-box.component";
import { SchedulePartnershipOfferSucessDialogBoxComponent } from "./shared/components/dialog-box/schedule-partnership-offer-sucess-dialog-box/schedule-partnership-offer-sucess-dialog-box.component";
import { PreviewComarketingOfferComponent } from "./shared/components/dialog-box/preview-comarketing-offer/preview-comarketing-offer.component";
import { ViewSurveyComponent } from "./modules/static/pages/view-survey/view-survey.component";
import { getdateformatService } from "./core/services/get-date-format.service";
import { CampaignChannelSelectComponent } from "./modules/pos/modules/campaign/component/campaign-channel-select/campaign-channel-select.component";
import { CountryDropdownComponent } from "./shared/components/country-dropdown/country-dropdown.component";
import { StoreService } from "./core/services/store.service";
import { OAuthRedirectDialogComponent } from "./shared/components/oauth-redirect-dialog/oauth-redirect-dialog.component";
// import { CountryDropdownWrapperComponent } from "./shared/components/country-dropdown/country-dropdown-wrapper-component/country-dropdown-wrapper-component.component";
import { TranslateText } from "./shared/pipes/translation.pipe";
import { TextTranslationService } from "./core/services/translate-text.service";
import { TranslateDynamicText } from "./shared/pipes/dynamic-translation.pipe";
import { SelectUserPageComponent } from "./modules/data-ingestion/pages/select-user-page/select-user-page.component";
import { OfferModule } from "./modules/pos/modules";
import { AddNewCustomerInListDialogBoxComponent } from "./shared/components/dialog-box/add-new-customer-in-list-dialog-box/add-new-customer-in-list-dialog-box.component";
import { PersonalOfferListViewDialogBoxComponent } from "./shared/components/dialog-box/personal-offer-list-view-dialog-box/personal-offer-list-view-dialog-box.component";
import { LineChartAnalyticsComponent } from "./shared/components/charts/line-chart-analytics/line-chart-analytics.component";
import { ScatterPlotChartAnalyticsComponent } from "./shared/components/charts/scatter-plot-chart-analytics/scatter-plot-chart-analytics.component";
import { FilterAnalyticsDialogBoxComponent } from "./shared/components/dialog-box/filter-analytics-dialog-box/filter-analytics-dialog-box.component";
import { DataPreviewAmalyticsDialogBoxComponent } from "./shared/components/dialog-box/data-preview-amalytics-dialog-box/data-preview-amalytics-dialog-box.component";
import { InsightGraphDialogBoxComponent } from "./shared/components/dialog-box/insight-graph-dialog-box/insight-graph-dialog-box.component";
import { NgxEchartsModule } from "ngx-echarts";
import { UploadCsvDialogBoxComponent } from "./shared/components/dialog-box/upload-csv-dialog-box/upload-csv-dialog-box.component";
import { getLogoUrlService } from "./core/services/get-logo-url.service";
import { ViewEmailTemplateComponent } from "./modules/pos/modules/email/pages/view-email-template/view-email-template.component";
import { EmailTemplateNameDialogComponent } from "./shared/components/dialog-box/email-template-name-dialog/email-template-name-dialog.component";
import { EmailTemplatePreviewDialogComponent } from "./shared/components/dialog-box/email-template-preview-dialog/email-template-preview-dialog.component";
import { EmailSampleListingComponent } from "./modules/pos/modules/email/pages";
import { DefaultExcluysionDialogBoxComponent } from "./shared/components/dialog-box/default-excluysion-dialog-box/default-excluysion-dialog-box.component";
import { OfferSummaryDialogV2Component } from "./shared/components/dialog-box/offer-summary-dialog-v2/offer-summary-dialog-v2.component";
import { ChallengesMilestoneDataService } from "./core/services/challenges-milestone-data.service";
import { TargetSpecificCustomerComponent } from "./shared/components/dialog-box/target-specific-customer/target-specific-customer.component";
import { NgxEditorModule } from "ngx-editor";
@NgModule({
  declarations: [
    AppComponent,
    SignupDialogComponent,
    EcommerceDialogComponent,
    ContactUsDialogComponent,
    OfferTemplateViewDialogComponent,
    CampaignTemplateViewDialogComponent,
    ConfirmationDialogBoxComponent,
    PopUpDialogComponent,
    SurveyPageCreationComponent,
    CamapignStrategyNodeDataComponent,
    CampaignStrategyDialogComponent,
    CampaignStrategyTooltipComponent,
    CustomerLeadsComponent,
    EmailEditorDialogComponent,
    HtmlDataDialogComponent,
    CommonTooltipDialogComponent,
    StandardCampaignActivateDialogComponent,
    SurveyAlertRecommendationDialogComponent,
    AddEmailSubjectDialogComponent,
    TemplateSelectComponent,
    HtmlForEmailTemplatesDialogComponent,
    BeeEditorProductImageConfigDialogComponent,
    DeleteDialogComponent,
    NodeDeleteBranchSelectorComponent,
    CampaignStrategyActivateDialogComponent,
    PreviewTemplateComponent,
    SuccessDialogComponent,
    SurveySchedulesSuccessComponent,
    SmsTemplateCreationDialogComponent,
    SmsScheduleDialogComponent,
    SmsPreviewDialogComponent,
    SelectOfferTypeDialogComponent,
    OfferSummaryDialogComponent,
    OfferChannelAddConfirmationDialogComponent,
    SmsPreviewIdDialogComponent,
    TargetingDialogComponent,
    PlanFeaturesComponent,
    OfferAddProductDialogComponent,
    ProductListDialogComponent,
    CollectionListDialogComponent,
    DataFetchingDialogComponent,
    SendTestEmailDialogComponent,
    DomainConfirmationDialogPopUpComponent,
    InactivePlanDialogComponent,
    ProductGameListDialogComponent,
    NameAndDescriptionComponent,
    InvitePartnerDialogComponent,
    PartnershipRewardCreationDialogboxComponent,
    PartnershipInitiateDialogBoxComponent,
    PartnershipSendOfferDialogboxComponent,
    ConnectPaypalComponent,
    DisablePartnershipOfferComponent,
    UpdateFormComponent,
    ExcludeProductDialogComponent,
    DialogOverviewComponent,
    // BreadcrumbComponent,
    MatSnackBarComponent,
    StaticHeaderComponent,
    StaticFooterComponent,
    PaymentPlanComponent,
    StaticPageComponent,
    SessionOutComponent,
    MobileAlertComponent,
    WelcomeWidgetComponent,
    MobileEmailPreviewComponent,
    NotFoundComponent,
    //EmailTemplatePreviewComponent,
    //ButtonDebounceDirective,
    DeleteGameDialogBoxComponent,
    NegotiatorTemplatePreviewComponent,
    OfferRulesImportDialogComponent,
    EmailTemplateCreationDialogComponent,
    DisableFormComponent,
    SendSmsConsentDialogBoxComponent,
    MyStorePreviewComponent,
    SelectStoreDialogBoxComponent,
    ViewStoreDialogBoxComponent,
    PaymentPosSucessDialogComponent,
    SocialMediaConnectChannelDialogComponent,
    SocialMediaPagesSelectDialogComponent,
    OfferCreateDialogComponent,
    AiEmailCreationComponent,
    AnalyticsChatGptComponent,
    CampaignFullscreenComponent,
    EmailNotVerifiedDialogBoxComponent,
    OfferCreateChatGptDialogBoxComponent,
    WhatsappTemplateCreationDialogComponent,
    OfferSelectDoalogBoxComponent,
    GroupOfferSucessDialogBoxComponent,
    SchedulePartnershipOfferSucessDialogBoxComponent,
    PreviewComarketingOfferComponent,
    ViewSurveyComponent,
    SelectUserPageComponent,
    // CampaignHowToCreateComponent,
    // SetUpCampaignComponent,
    // CampaignAddFilterComponent
    CountryDropdownComponent,
    // CountryDropdownWrapperComponent
    OAuthRedirectDialogComponent,
    AddNewCustomerInListDialogBoxComponent,
    PersonalOfferListViewDialogBoxComponent,
    FilterAnalyticsDialogBoxComponent,
    DataPreviewAmalyticsDialogBoxComponent,
    InsightGraphDialogBoxComponent,
    UploadCsvDialogBoxComponent,
    ViewEmailTemplateComponent,
    EmailTemplateNameDialogComponent,
    EmailTemplatePreviewDialogComponent,
    EmailSampleListingComponent,
    SearchCustomerDialogBoxComponent,
    TableViewDialogBoxComponent,
    NotDeletedListDialogBoxComponent,
    SearchModulesDialogBoxComponent,
    AnalyticsCustomerListDialogBoxComponent,
    DefaultExcluysionDialogBoxComponent,
    OfferSummaryDialogV2Component,
    AbGraphInsightDialogComponent,
    SendTestSmsDialogComponent,
    SelectionChallengeTypeDialogComponent,
    MilestoneCreationDialogComponent,
    TargetSpecificCustomerComponent,
    PushNotificationPreviewDialogBoxComponent
  ],
  imports: [
    NgCircleProgressModule.forRoot({
      outerStrokeLinecap: "square",
    }),
    BrowserModule,
    FormsModule,
    BrowserAnimationsModule,
    MatToolbarModule,
    MatProgressBarModule,
    MatSidenavModule,
    MatButtonModule,
    MatListModule,
    MatCardModule,
    MatGridListModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    ReactiveFormsModule,
    HttpClientModule,
    MatProgressSpinnerModule,
    MatDialogModule,
    MatCheckboxModule,
    AppRoutingModule,
    MatRadioModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSlideToggleModule,
    MatTableModule,
    MatPaginatorModule,
    MatMenuModule,
    MatTabsModule,
    MatSnackBarModule,
    MatExpansionModule,
    ColorPickerModule,
    MentionModule,
    MatChipsModule,
    NgxMaterialTimepickerModule,
    MatStepperModule,
    ProgressBarModule,
    Ng2TelInputModule,
    // MatBadgeModule,
    DragDropModule,
    // NgbModule,
    NgxMatSelectSearchModule,
    MatIconModule,
    NgxSliderModule,
    NgxEmojiPickerModule.forRoot(),
    MatTreeModule,
    OfferModule,
    SharedModule,
    MatAutocompleteModule,
    EmojiPickerLazyModule,
    AgmCoreModule.forRoot({
      apiKey: environment.googleMapsApiKey,
      libraries: ["places"],
    }),
    NgxEchartsModule.forRoot({
      /**
       * This will import all modules from echarts.
       * If you only need custom modules,
       * please refer to [Custom Build] section.
       */
      echarts: () => import("echarts"), // or import('./path-to-my-custom-echarts')
    }),
    NgxEditorModule
  ],
  providers: [
    { provide: MatDialogRef, useValue: {} },
    DatePipe,
    ApiCallService,
    httpInterceptorProviders,
    ErrorHandler,
    MatSnackBarComponent,
    MatDatepickerModule,
    { provide: MAT_DATE_LOCALE, useValue: "en-GB" },
    MatNativeDateModule,
    dataBase,
    EventsService,
    FontCollection,
    SnackbarCollection,
    WindowRef,
    Globals,
    PygApiCallService,
    ParentChildService,
    WidgetConfigService,
    WidgetRouteGaurdService,
    [DatePipe],
    EventIconMappingService,
    SubscriptionPlanHandlerService,
    currentPlanDataService,
    SignoutService,
    create360dialogaccoountService,
    StoreService,
    TextTranslationService,
    TranslateText,
    TranslateDynamicText,
    getdateformatService,
    getLogoUrlService,
    ChallengesMilestoneDataService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
